export default __webpack_public_path__ + "static/O0196-6a3cfd22ed7d9a820c2ccf7f4433d2f3.png";